import React, { Component } from 'react';
import { renderPages } from '../Utilities/newsUtil';
class Pagination extends Component {
    render() {
        const { pageSize, size, pageChangeHandler, currentPage } = this.props;
        const arrayOfPages = renderPages(size, pageSize);
        return (
            <div className="d-flex justify-content-center ">
                <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        <li className={"page-item " + (currentPage === 1 ? "disabledPage disabled" : "")} onClick={() => pageChangeHandler(currentPage === 1 ? currentPage : currentPage - 1)}>
                            <span className="page-link" aria-hidden="true">&laquo;</span>
                        </li>
                        {arrayOfPages.map(pageNo => {
                            return (
                                <li key={pageNo} className={'page-item ' + (currentPage === pageNo ? "active" : "")} onClick={() => pageChangeHandler(pageNo)}><p className="page-link">{pageNo}</p></li>
                            )
                        })}
                        <li className={"page-item " + (currentPage === arrayOfPages.length ? "disabledPage disabled" : "")} onClick={() => pageChangeHandler(currentPage === arrayOfPages.length ? currentPage : currentPage + 1)}>
                            <span className="page-link" aria-hidden="true">&raquo;</span>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default Pagination;